import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import AuthContext from './AuthContext';
import ProtectedRoute from './ProtectedRoute';

import Login from './components/Login';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
//import Register from './components/Register';

import Dashboard from './pages/Dashboard';
import Profile from './pages/Profile';
import Company from './pages/Company';
import Changepassword from './pages/Changepassword';
import Billing from './pages/Billing';
import Cancelbill from './pages/Cancelbill';
import Dailyreport from './pages/Dailyreport';
import Bulkbill from './pages/Bulkbill';
import Bulksearchbill from './pages/Bulksearchbill';
import Buyer from './pages/Buyer';
import Bulkupload from './pages/Bulkupload';
import Dealer from './pages/Dealer';
import Searchbill from './pages/Searchbill';
import Stocks from './pages/Stocks';
import Finance from './pages/Finance';
import Addfinance from './pages/Addfinance';
import Exchange from './pages/Exchange';
import AddExchange from './pages/AddExchange';
import AddReceipt from './pages/AddReceipt';
import DueReceiptTable from './pages/DueReceiptTable';
import Viewfinance from './pages/Viewfinance';
import EmiCalculator from './pages/EmiCalculator';
import Seizedvehicle from './pages/Seizedvehicle';
import Register from './pages/Register';
import UserManagement from './pages/UserManagement';
import Collection from './pages/Collection';
import FullSettlement from './pages/FullSettlement';
import PlansPage from './pages/PlansPage';
import PricingPage from './pages/PricingPage';
import PaymentHistory from './pages/PaymentHistory';
import BasicDashboard from './pages/BasicDashboard';
import Reports from './pages/Reports';
import ReportDetail from './pages/ReportDetail';
import Accounts from './pages/Accounts';
import AccountsBusinessSummary from './pages/AccountsBusinessSummary';
import AccountsEmiCollection from './pages/AccountsEmiCollection';
import AccountsOutstandingAging from './pages/AccountsOutstandingAging';
import AccountsCustomerLedger from './pages/AccountsCustomerLedger';
import AccountsProfitLoss from './pages/AccountsProfitLoss';
import MarketplaceDashboard from './pages/MarketplaceDashboard';
import MarketplaceListings  from './pages/MarketplaceListings';
import MarketplaceLeads     from './pages/MarketplaceLeads';
import MarketplaceAnalytics from './pages/MarketplaceAnalytics';
import MarketplaceReviews   from './pages/MarketplaceReviews';

const pageComponents = {
  dashboard: <Dashboard />,
  profile: <Profile />,
  company: <Company />,
  changepassword: <Changepassword />,
  billing: <Billing />,
  cancelbill: <Cancelbill />,
  dailyreport: <Dailyreport />,
  bulkbill: <Bulkbill />,
  bulksearchbill: <Bulksearchbill />,
  buyer: <Buyer />,
  bulk_upload: <Bulkupload />,
  dealer: <Dealer />,
  search_bill: <Searchbill />,
  stocks: <Stocks />,
  finance: <Finance />,
  addfinance: <Addfinance />,
  exchange: <Exchange />,
  addexchange: <AddExchange />,
  addreceipt: <AddReceipt />,
  duereceipt: <DueReceiptTable />,
  viewfinance: <Viewfinance />,
  emicalculator: <EmiCalculator />,
  seizedvehicle: <Seizedvehicle />,
  register: <Register />,
  user: <UserManagement />,
  collection: <Collection />,
  fullsettlement: <FullSettlement />,
  plans: <PlansPage />,
  pricing: <PricingPage />,
  paymenthistory: <PaymentHistory />,
  reports: <Reports />,
  accounts: <Accounts />,
};

const pathMapping = {
  dashboard: "/dashboard",
  profile: "/profile",
  company: "/company",
  changepassword: "/changepassword",
  billing: "/billing",
  cancelbill: "/cancelbill",
  dailyreport: "/dailyreport",
  bulkbill: "/bulkbill",
  bulksearchbill: "/bulksearchbill",
  buyer: "/buyer",
  bulk_upload: "/bulk-upload",
  dealer: "/dealer",
  search_bill: "/search-bill",
  stocks: "/stocks",
  finance: "/finance",
  addfinance: "/addfinance",
  exchange: "/exchange",
  addexchange: "/addexchange",
  addreceipt: "/addreceipt",
  duereceipt: "/duereceipt",
  viewfinance: "/viewfinance",
  emicalculator: "/emicalculator",
  seizedvehicle: "/seizedvehicle",
  register: "/register",
  user: "/user",
  collection: "/collection",
  fullsettlement: "/fullsettlement",
  plans: "/plans",
  pricing: "/pricing",
  paymenthistory: "/paymenthistory",
  reports: "/reports",
  accounts: "/accounts",
};

// Renders BasicDashboard for Basic plan, full Dashboard for all others
const DashboardPage = () => {
  const { isPlanAllowed } = React.useContext(AuthContext);
  return isPlanAllowed('emicalculator') ? <Dashboard /> : <BasicDashboard />;
};

const AppContent = () => {
  const { isAuthenticated, loading, permissions = [], isPlanAllowed } = React.useContext(AuthContext);
  const location = useLocation();

  // Check if the current path is "/login"
  const isLoginPage = location.pathname === '/login';

  if (loading) return <div>Loading App...</div>;


  return (
    <div className="App">
      {!isLoginPage ? (
        <div className="wrapper">
          {/* Only render sidebar, header, and footer if authenticated */}

          {isAuthenticated && <Header />}
          {isAuthenticated && <Sidebar />}
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                isAuthenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
              }
            />
            {/* Dashboard: BasicDashboard for Basic plan, regular Dashboard for others */}
            {isPlanAllowed('dashboard') && (
              <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            )}
            {permissions.map((perm, index) => {
              const path = pathMapping[perm];
              const component = pageComponents[perm];
              if (path && component && isPlanAllowed(perm)) {
                return (
                  <Route
                    key={index}
                    path={path}
                    element={<ProtectedRoute>{component}</ProtectedRoute>}
                  />
                );
              }
              return null;
            })}
            {/* Reports + Accounts: plan-only gating — no role permission required */}
            {isPlanAllowed('reports')  && <Route path="/reports"  element={<ProtectedRoute><Reports  /></ProtectedRoute>} />}
            {isPlanAllowed('accounts') && <Route path="/accounts" element={<ProtectedRoute><Accounts /></ProtectedRoute>} />}
            {/* Report sub-routes — gated by individual plan keys only */}
            {isPlanAllowed('report_purchase')    && <Route path="/reports/purchase"    element={<ProtectedRoute><ReportDetail reportType="purchase"    /></ProtectedRoute>} />}
            {isPlanAllowed('report_sales')       && <Route path="/reports/sales"       element={<ProtectedRoute><ReportDetail reportType="sales"       /></ProtectedRoute>} />}
            {isPlanAllowed('report_stock')       && <Route path="/reports/stock"       element={<ProtectedRoute><ReportDetail reportType="stock"       /></ProtectedRoute>} />}
            {isPlanAllowed('report_outstanding') && <Route path="/reports/outstanding" element={<ProtectedRoute><ReportDetail reportType="outstanding" /></ProtectedRoute>} />}
            {isPlanAllowed('report_collection')  && <Route path="/reports/collection"  element={<ProtectedRoute><ReportDetail reportType="collection"  /></ProtectedRoute>} />}
            {/* Account sub-routes — gated by individual plan keys only */}
            {isPlanAllowed('account_summary')    && <Route path="/accounts/summary"    element={<ProtectedRoute><AccountsBusinessSummary  /></ProtectedRoute>} />}
            {isPlanAllowed('account_collection') && <Route path="/accounts/collection" element={<ProtectedRoute><AccountsEmiCollection    /></ProtectedRoute>} />}
            {isPlanAllowed('account_aging')      && <Route path="/accounts/aging"      element={<ProtectedRoute><AccountsOutstandingAging /></ProtectedRoute>} />}
            {isPlanAllowed('account_ledger')     && <Route path="/accounts/ledger"     element={<ProtectedRoute><AccountsCustomerLedger   /></ProtectedRoute>} />}
            {isPlanAllowed('account_pl')         && <Route path="/accounts/pl"         element={<ProtectedRoute><AccountsProfitLoss       /></ProtectedRoute>} />}
            {/* Plans / billing — always available when authenticated */}
            <Route path="/plans"          element={<ProtectedRoute><PlansPage      /></ProtectedRoute>} />
            <Route path="/pricing"        element={<ProtectedRoute><PricingPage    /></ProtectedRoute>} />
            <Route path="/paymenthistory" element={<ProtectedRoute><PaymentHistory /></ProtectedRoute>} />
            {/* Marketplace — no permission gate, always available when authenticated */}
            <Route path="/marketplace"           element={<ProtectedRoute><MarketplaceDashboard /></ProtectedRoute>} />
            <Route path="/marketplace/listings"  element={<ProtectedRoute><MarketplaceListings  /></ProtectedRoute>} />
            <Route path="/marketplace/leads"     element={<ProtectedRoute><MarketplaceLeads     /></ProtectedRoute>} />
            <Route path="/marketplace/analytics" element={<ProtectedRoute><MarketplaceAnalytics /></ProtectedRoute>} />
            <Route path="/marketplace/reviews"   element={<ProtectedRoute><MarketplaceReviews   /></ProtectedRoute>} />
          </Routes>
          <aside className="control-sidebar control-sidebar-dark"></aside>
          {isAuthenticated && <Footer />}
        </div>
      ) : (
        // Render only the login page without the wrapper and main layout
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      )}
    </div>
  );
}

const App = () => (
  <AuthProvider>
    <Router>
      <AppContent />
    </Router>
  </AuthProvider>
);

export default App;
